<select-search
  [label]="label"
  [item]="item"
  [placeholder]="placeholder"
  [control]="control"
  [optimalSearch]="optimalSearch"
  [isDisabled]="isDisabled"
  [loading]="initLoading"
  [id]="id"
  [isFetchData]="isFetchData"
  [isDeleteAfterEmit]="isDeleteAfterEmit"
  [removable]="removable"
  [isShowRefreshBtn]="isShowRefreshBtn"
  [isDefaultValue]="isDefaultValue"
  [optionTitle]="optionTitle"
  [optionValue]="optionValue"
  [items]="items"
  [value]="value"
  (valueChange)="emitOptionValue($event)"
  (itemChange)="emitOption($event)"
  (onRefresh)="refreshItems()"
>
</select-search>
